import { createContext } from '@lyearn/core/utils/context';
import { LanguageEnum } from '@/types/schema';

import { QuizState } from '../../types';

export interface QuizDetailsContextValue {
  fetchingRetakeQuiz: boolean;
  onBackToHome: () => void;
  onRetakeQuiz: () => void;
  onRetakeQuizAndToggle: () => void;
  quizState: QuizState;
  onShowQuiz: () => void;
  onCloseQuiz: () => void;
  onShowAttemptHistory?: () => void;
  userId: string;
  isParentPathLocalizedContent?: boolean;
  isLocalizedContent?: boolean;
  pauseActivity?: boolean;
  languageType?: LanguageEnum;
}

const [QuizDetailsProvider, useQuizDetailsContext] =
  createContext<QuizDetailsContextValue>('QuizDetailsContext');

export { useQuizDetailsContext };
export default QuizDetailsProvider;
